setTimeout(function(){
  
  const fullscreenButtonstwoo = document.querySelector('.fullscreen');  
  fullscreenButtonstwoo?.addEventListener('click', function() {
      document.body.classList.toggle('fullscreen')
  });


  const previewBlock = document.querySelector('.preview-block power-viewer');
  if (previewBlock) {
      previewBlock.style.display = 'initial'; // Rendre visible le bloc
  }

  const listContainer = document.querySelector('#splide01-list');
  const firstSliderColor = listContainer.querySelector('[id^="splide01-slide"]');

  firstSliderColor.style.backgroundColor = "#e2dbd5"

},2000)

const observer = new MutationObserver((mutationsList, observer) => {
  if (document.querySelector(".power-viewer-switch.loaded")) {
    let fullscreen = document.querySelector(".emojiFullscreen");
    fullscreen.style.display = "block";
    observer.disconnect();  
  }
});

observer.observe(document.body, { childList: true, subtree: true });